import React from "react";
import styles from "./CardsSkeleton.module.scss";

export const CardsSkeleton: React.FC = () => {
  return (
    <div className={styles.items}>
      {Array.from({ length: 2 }).map((_, i) => (
        <div key={i} className={styles.cardItem}>
          <div className={styles.cardLeft}>
            <div className={styles.iconSkeleton} />
            <div className={styles.numberSkeleton} />
          </div>
          <div className={styles.trashSkeleton} />
        </div>
      ))}
      <div className={styles.addCardSkeleton} />
    </div>
  );
};
